module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1003-42b5f082baa8542055a8b151dfcd1c1a.png";